var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendNewmsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.598,
    height: 13.598,
    viewBox: "0 0 15.598 15.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(0.75 0.848)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x1: 7.541,
    y2: 7.541,
    transform: "translate(6.246 0.213)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M16,2,11.1,16,8.3,9.7,2,6.9Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNewmsgIcon);
export default __webpack_public_path__ + "static/media/send-newmsg-icon.cd9f60c159bcaa3e7f8e0d4738e6148e.svg";
export { ForwardRef as ReactComponent };